'use client';

import { ResourceStatus } from './resource-status';
import { useProjectCardContext } from './project-card-context';
import type { ReactNode } from 'react';
export function ProjectCardInstances({
  instanceController
}: {
  instanceController: ReactNode;
}) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div onClick={e => e.preventDefault()} className="hidden lg:flex" data-sentry-component="ProjectCardInstances" data-sentry-source-file="project-card-children.tsx">
      {instanceController}
    </div>
  );
}
export function ProjectCardResourceStatus() {
  const {
    slug
  } = useProjectCardContext();
  return <ResourceStatus slug={slug} data-sentry-element="ResourceStatus" data-sentry-component="ProjectCardResourceStatus" data-sentry-source-file="project-card-children.tsx" />;
}
export function ProjectCardTokens() {
  return <div data-sentry-component="ProjectCardTokens" data-sentry-source-file="project-card-children.tsx">12 tokens left</div>;
}